module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.val),
      expression: "val"
    }],
    class: ['alert', 'alert-' + _vm.type, _vm.placement],
    style: ({
      width: _vm.width
    }),
    attrs: {
      "role": "alert"
    }
  }, [_vm._c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dismissable),
      expression: "dismissable"
    }],
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.val = false
      }
    }
  }, [_vm._c('span', [_vm._v("×")])]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-af7c1f6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af7c1f6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Alert.vue
// module id = 129
// module chunks = 0